import { render, staticRenderFns } from "./CloseTipIcon.vue?vue&type=template&id=2f79e415&"
import script from "./CloseTipIcon.vue?vue&type=script&lang=ts&"
export * from "./CloseTipIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports